import { createConsumer } from "@rails/actioncable";

const getCableUrl = () => {
  if (process.env.NODE_ENV !== "production") {
    return "ws://localhost:3000/cable";
  }

  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";

  return `${protocol}//${window.location.host}/cable`;
};

const consumer = createConsumer(getCableUrl());

export const subscribeToProgress = (downloadToken, onMessage) => {
  if (!downloadToken) {
    console.error("Missing download token for subscription");
    return null;
  }

  console.log("Subscribing to channel with downloadToken:", downloadToken);
  console.log("Action Cable URL:", getCableUrl());

  return consumer.subscriptions.create(
    {
      channel: "SubtitleProgressChannel",
      download_token: downloadToken,
    },
    {
      connected() {
        console.log("Connected to Action Cable");
      },

      disconnected() {
        console.log("Disconnected from Action Cable");
      },

      rejected() {
        console.error("Subscription was rejected for token:", downloadToken);
      },

      received(data) {
        console.log("Received data from channel:", data);

        if (typeof data !== "object") {
          console.warn("Unexpected data format:", data);
          return;
        }

        onMessage(data);
      },
    }
  );
};